import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';


/**
 * Generated class for the ThirdpartywebpopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-thirdpartywebpopup',
  templateUrl: 'thirdpartywebpopup.html',
})
export class ThirdpartywebpopupPage {
  httplink : any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public sanitizer: DomSanitizer) {
    this.httplink = this.navParams.get('url');
    this.httplink=this.sanitizer.bypassSecurityTrustResourceUrl(this.httplink);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ThirdpartywebpopupPage');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/thirdpartywebpopup/thirdpartywebpopup.ts